import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=14c303b5&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c303b5')) {
      api.createRecord('14c303b5', component.options)
    } else {
      api.reload('14c303b5', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=14c303b5&", function () {
      api.rerender('14c303b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/comp/stardisplay.vue"
export default component.exports